// Available background images (hardcoded)
// path: compressed version for actual background use
// thumbnail: thumbnail version for modal preview

// compressed
import alligatorsTurtlesPath from "assets/backgrounds/compressed/alligators-turtles-busch-gardens.jpg";
import bostonCommonPath from "assets/backgrounds/compressed/boston-common-massachusetts.jpg";
import collapsingBarnPath from "assets/backgrounds/compressed/collapsing-barn-idaho.jpg";
import ferrisWheelPath from "assets/backgrounds/compressed/ferris-wheel-orlando.jpg";
import glendaleMillPath from "assets/backgrounds/compressed/glendale-mill-south-carolina.jpg";
import goldenGatePath from "assets/backgrounds/compressed/golden-gate-bridge-san-francisco.jpg";
import hinduTemplePath from "assets/backgrounds/compressed/hindu-temple-madrid-iowa.jpg";
import joshuaTreePath from "assets/backgrounds/compressed/joshua-tree-national-park.jpg";
import lifeguardTowerPath from "assets/backgrounds/compressed/lifeguard-tower-oregon.jpg";
import lighthousePath from "assets/backgrounds/compressed/lighthouse-florida.jpg";
import nikkeiMonumentPath from "assets/backgrounds/compressed/nikkei-monument-portland-oregon.jpg";
import rockyMountainsPath from "assets/backgrounds/compressed/rocky-mountains-wildflowers.jpg";
import scullingPath from "assets/backgrounds/compressed/sculling-charles-river-boston.jpg";
import seattleWaterfrontPath from "assets/backgrounds/compressed/seattle-waterfront-washington.jpg";
import sunsetFencePath from "assets/backgrounds/compressed/sunset-fence-alabama.jpg";
import swampTreesPath from "assets/backgrounds/compressed/swamp-trees-louisiana.jpg";
import waterfallPath from "assets/backgrounds/compressed/waterfall-hawaii.jpg";

// thumbnails
import alligatorsTurtlesThumb from "assets/backgrounds/thumbnails/alligators-turtles-busch-gardens.jpg";
import bostonCommonThumb from "assets/backgrounds/thumbnails/boston-common-massachusetts.jpg";
import collapsingBarnThumb from "assets/backgrounds/thumbnails/collapsing-barn-idaho.jpg";
import ferrisWheelThumb from "assets/backgrounds/thumbnails/ferris-wheel-orlando.jpg";
import glendaleMillThumb from "assets/backgrounds/thumbnails/glendale-mill-south-carolina.jpg";
import goldenGateThumb from "assets/backgrounds/thumbnails/golden-gate-bridge-san-francisco.jpg";
import hinduTempleThumb from "assets/backgrounds/thumbnails/hindu-temple-madrid-iowa.jpg";
import joshuaTreeThumb from "assets/backgrounds/thumbnails/joshua-tree-national-park.jpg";
import lifeguardTowerThumb from "assets/backgrounds/thumbnails/lifeguard-tower-oregon.jpg";
import lighthouseThumb from "assets/backgrounds/thumbnails/lighthouse-florida.jpg";
import nikkeiMonumentThumb from "assets/backgrounds/thumbnails/nikkei-monument-portland-oregon.jpg";
import rockyMountainsThumb from "assets/backgrounds/thumbnails/rocky-mountains-wildflowers.jpg";
import scullingThumb from "assets/backgrounds/thumbnails/sculling-charles-river-boston.jpg";
import seattleWaterfrontThumb from "assets/backgrounds/thumbnails/seattle-waterfront-washington.jpg";
import sunsetFenceThumb from "assets/backgrounds/thumbnails/sunset-fence-alabama.jpg";
import swampTreesThumb from "assets/backgrounds/thumbnails/swamp-trees-louisiana.jpg";
import waterfallThumb from "assets/backgrounds/thumbnails/waterfall-hawaii.jpg";

export const BACKGROUND_IMAGES = [
  {
    key: "alligators_turtles",
    name: "Alligators & Turtles, Busch Gardens",
    path: alligatorsTurtlesPath,
    thumbnail: alligatorsTurtlesThumb,
  },
  {
    key: "boston_common",
    name: "Boston Common, Massachusetts",
    path: bostonCommonPath,
    thumbnail: bostonCommonThumb,
  },
  {
    key: "collapsing_barn",
    name: "Collapsing Barn, Idaho",
    path: collapsingBarnPath,
    thumbnail: collapsingBarnThumb,
  },
  {
    key: "ferris_wheel",
    name: "Ferris Wheel, Orlando",
    path: ferrisWheelPath,
    thumbnail: ferrisWheelThumb,
  },
  {
    key: "glendale_mill",
    name: "Glendale Mill, South Carolina",
    path: glendaleMillPath,
    thumbnail: glendaleMillThumb,
  },
  {
    key: "golden_gate",
    name: "Golden Gate Bridge, San Francisco",
    path: goldenGatePath,
    thumbnail: goldenGateThumb,
  },
  {
    key: "hindu_temple",
    name: "Hindu Temple, Madrid, Iowa",
    path: hinduTemplePath,
    thumbnail: hinduTempleThumb,
  },
  {
    key: "joshua_tree",
    name: "Joshua Tree National Park",
    path: joshuaTreePath,
    thumbnail: joshuaTreeThumb,
  },
  {
    key: "lifeguard_tower",
    name: "Lifeguard Tower, Oregon",
    path: lifeguardTowerPath,
    thumbnail: lifeguardTowerThumb,
  },
  {
    key: "lighthouse_florida",
    name: "Lighthouse, Florida",
    path: lighthousePath,
    thumbnail: lighthouseThumb,
  },
  {
    key: "nikkei_monument",
    name: "Nikkei Monument, Portland, Oregon",
    path: nikkeiMonumentPath,
    thumbnail: nikkeiMonumentThumb,
  },
  {
    key: "rocky_mountains",
    name: "Rocky Mountains Wildflowers",
    path: rockyMountainsPath,
    thumbnail: rockyMountainsThumb,
  },
  {
    key: "sculling_charles_river",
    name: "Sculling, Charles River, Boston",
    path: scullingPath,
    thumbnail: scullingThumb,
  },
  {
    key: "seattle_waterfront",
    name: "Seattle Waterfront, Washington",
    path: seattleWaterfrontPath,
    thumbnail: seattleWaterfrontThumb,
  },
  {
    key: "sunset_fence",
    name: "Sunset Fence, Alabama",
    path: sunsetFencePath,
    thumbnail: sunsetFenceThumb,
  },
  {
    key: "swamp_trees",
    name: "Swamp Trees, Louisiana",
    path: swampTreesPath,
    thumbnail: swampTreesThumb,
  },
  {
    key: "waterfall_hawaii",
    name: "Waterfall, Hawaii",
    path: waterfallPath,
    thumbnail: waterfallThumb,
  },
];

/** Get background image by key (used when resolving backgroundValue from preferences). */
export function getBackgroundImageByKey(key) {
  if (!key) return null;
  return BACKGROUND_IMAGES.find((img) => img.key === key) ?? null;
}
